module.exports = __webpack_public_path__ + "img/lifestyle_thumbnail-400x300.9f8ef1c4.jpg";